import BaseLayout from '../components/base-layout';
import { BaseLayoutFactory } from '../components/base-layout-factory';
import PageUnauthorized from './page-unauthorized';

export function PageUnauthorizedFactory() {
    return (
        <BaseLayout>
            <PageUnauthorized />
        </BaseLayout>
    );
}
